import http from '@/requests/http'

class BranchExtension {
  static findAll () {
    return http.post('branch-extension/index')
  }
  static storeDid (params) {
    return http.post('branch-extension/store/did', params)
  }
  static storeExtension (params) {
    return http.post('branch-extension/store/extension', params)
  }
  static fetchDidExtension (params) {
    return http.post('branch-extension/did/extension', params)
  }
  static destroyExtension (params) {
    return http.post('branch-extension/destroy/extension', params)
  }
}

export default BranchExtension
